import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { dashBoardFilterBy } from 'src/app/dummy/status';
import { debounceTime, tap, switchMap } from 'rxjs/operators';
import { SearchStore } from 'src/app/stores/search.store';
import { Auth } from 'src/app/stores/auth.store';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  formFocus: boolean;
  form: FormGroup;
  search: AbstractControl;
  searchType: AbstractControl;
  filterBy = dashBoardFilterBy;
  loading: boolean = false;
  filterData = [];
  selectedFilter = null;
  selectedItem = null;
  constructor(
    public db: AngularFirestore,
    private fb: FormBuilder,
    public store: SearchStore,
    public auth: Auth
  ) { }

  ngOnInit() {
    this.selectedFilter = this.filterBy[0]
    this.form = this.fb.group({
      searchType: [this.selectedFilter, [Validators.required]],
      search: [null,Validators.required]
    });
    this.search = this.form.controls["search"];
    this.searchType = this.form.controls["searchType"];
    this.search.valueChanges
      .pipe(
        debounceTime(300),
        tap(() => (this.loading = true)),
        switchMap(value => this.store.search(this.searchType.value, this.auth.selectedCompany.key, this.searchType.value.filterBy, value))
      )
      .subscribe(results => {
        this.filterData = results
        this.loading = false;
      });
      this.store.search(this.searchType.value, this.auth.selectedCompany.key, this.searchType.value.filterBy, '~N/A~')

  }

  displayItem(item: any):string {
    return item ? item[this.form&&this.form.value ? this.form.value.searchType.field : 'keyword'] : item;
  }

  compareObjects(o1: any, o2: any): boolean {
    if (o2) {
      return o1.text === o2.text;
    }
  }
  _onFocus(yes) {
    this.formFocus = yes;
  }

  _selectionChange(event) {
    const { value } = event;
    this.selectedItem = null
    this.filterData = []
    this.form.patchValue({
      searchType: value
    })
    this.selectedFilter = value

  }
  clearResult() {
    this.selectedItem = null
    this.filterData = []
  }
  _optionSelected(item: any) {
    this.selectedItem = item;
  }
  _onSearch(f) {
    // this.store.search(this.searchType.value, this.auth.selectedCompany.key, 'keyword', value)
  }


}
